<script>
import { mapActions } from 'vuex'
export default {
  name: 'Logout',
  created() {
    this.logout().then(() => {
      location.reload(true)
    })
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
  },
  render() { return '' },
}
</script>
